"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhone = formatPhone;
exports.makeOfferLink = exports.makeName = void 0;
var _types = require("../types");
/**
 * Форматирует телефон
 *
 * @param phone - телефон
 * @param cityCodeNotNecessary - без учета кода города
 */
function formatPhone(phone, cityCodeNotNecessary) {
  let mask = cityCodeNotNecessary ? '$1 ($2) $3-$4-$5' : '$1 $2 $3-$4-$5';
  if (/^7\d{10}$/.test(phone)) {
    mask = `+${mask}`;
  }
  return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, mask);
}

/**
 * Формирует ссылку на оффер по id
 *
 * @param id - ID объявления
 */
const makeOfferLink = id => `/sale/suburban/${id}`;

/**
 * Формирует читабельный тип для превью оффера по ключу
 *
 * @param objectType - ключ типа оффера
 */
exports.makeOfferLink = makeOfferLink;
const makeName = objectType => {
  switch (objectType) {
    case _types.EObjectType.COTTAGE:
    case _types.EObjectType.HOUSE:
      {
        return 'Дом';
      }
    case _types.EObjectType.LAND:
      {
        return 'Участок';
      }
    case _types.EObjectType.TOWNHOUSE:
      {
        return 'Таунхаус';
      }
    case _types.EObjectType.HOUSE_SHARE:
      {
        return 'Часть дома';
      }
    default:
      {
        return '';
      }
  }
};
exports.makeName = makeName;